import React from 'react';
import style from './env.module.sass'

interface Props {
    env: any
}

const Properties: React.FC<Props> = (props) => {
    const env = props.env;
    const info = env && [
        {
            title: 'Host URL',
            value: env.url
        },
        {
            title: 'Name',
            value: env.name
        },
        {
            title: 'Created Date',
            value: env.createdAt
        },
        {
            title: 'API Key',
            value: env.apiKey
        },
    ]
    return (
        <React.Fragment>
            <div data-test-id="properties" className={style.listContainer}>
                {
                    info &&
                    info.map((item: any, index: number) => {
                        return (
                            <div key={index} className={style.itemContainer}>
                                <div className={style.itemTitle} style={{ width: 200 }}>{item.title}</div>
                                &nbsp;<strong>:</strong>&nbsp;&nbsp;
                                <div data-test-id={`${item.value}`} className={style.itemValue} style={{ width: 800, whiteSpace: "normal", wordBreak: "break-word" }}>{item.value}</div>
                            </div>
                        )
                    })
                }
            </div>
        </React.Fragment>
    )
}

export default Properties;
